import css from 'styled-jsx/css';
import { icons } from '../../config/styles';
import { svgToDataUri } from '../../utils/styles/svgMixins';

const ShippingDetailsStyles = css`
  .shipping-details {
    margin-bottom: 12px;
    list-style: none;

    li {
      display: flex;

      @mixin mobileToTablet {
        align-items: baseline;
      }
    }

    .icon {
      display: inline-block;
      margin-right: 10px;
      margin-bottom: 0;

      @mixin tabletToDesktop {
        margin-bottom: 4px;
      }
    }

    .shipping-wrapper {
      align-items: center;
      display: inline-flex;
      background-color: #f1f1f1;
      border-radius: 4px;
      padding: 2px 4px;
      margin: 0 6px 6px 0;
      flex-direction: row;
      gap: 5px;

      span {
        font-size: 1.4rem;
        color: #008000;
      }
    }
    .express-icon,
    .scheduled-icon,
    .store-icon {
      background-repeat: no-repeat;
      background-position: center;
      background-size: contain;
      height: 16px;
      width: 16px;
      flex-shrink: 0;
    }

    .express-icon {
      background-image: url('${svgToDataUri(icons.expressShipping)}');
    }

    .scheduled-icon {
      background-image: url('${svgToDataUri(icons.scheduledShipping)}');
    }

    .store-icon {
      background-image: url('${svgToDataUri(icons.pickupFromStoreShipping)}');
    }
  }
`;

export default ShippingDetailsStyles;
